import { createContext, useContext } from 'react'

export const KvitteringIdContext = createContext<string>('')
export const KvitteringIdProvider = KvitteringIdContext.Provider

export const useKvitteringId = () => useContext(KvitteringIdContext)
